import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appAlphanumericOnly]'
})
export class AlphanumericOnlyDirective {
  // Allow alphanumeric characters
  private regex: RegExp = new RegExp(/^[a-zA-Z0-9]*$/);
  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  private specialKeys: Array<string> = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    'ArrowLeft',
    'ArrowRight',
    'Delete',
    'Control',
    'a',
    'c',
    'v'
  ];

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, home keys and control key combinations
    if (
      this.specialKeys.indexOf(event.key) !== -1 ||
      (event.ctrlKey === true && ['a', 'c', 'v'].includes(event.key))
    ) {
      return;
    }

    const current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [
      current.slice(0, position),
      event.key,
      current.slice(position)
    ].join('');

    // Check if the entered key is alphanumeric or not
    if (next && !String(event.key).match(this.regex)) {
      event.preventDefault();
    }
  }
}
